#@import GliveBooking.Models.Section
#@export GliveBooking.Collections.Sections

class GliveBooking.Collections.Sections extends BookingV2.Collections.Base
  model: GliveBooking.Models.Section
